//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SalesTab from "@/pages/SalesDashboard/components/SalesTab.vue";
import StocksTab from "@/pages/SalesDashboard/components/StocksTab.vue";
import BackendServices from "@/services/backend-services.js";
import moment from "moment";
import { EventBus } from "@/event-bus.js";

export default {
  name: "FieldSalesTab",
  props: ["tab", "showGraph"],
  components: {
    SalesTab,
    StocksTab,
  },
  mounted: function () {
    this.updateEmployeeList();

    BackendServices.getRetailers().then((response) => {
      this.retailerList = response.data;
    });

    BackendServices.getSalesFieldList().then((response) => {
      this.fields = response.data;
      this.fieldId = this.fields[0].id;
    });

    EventBus.$on("clear-dashboard", this.clearData);
  },
  data: function () {
    return {
      slide: 1,
      employeeSearch: null,
      employeeCount: null,
      employeeIds: [],
      pagination: {
        page: 1,
        rowsPerPage: 6,
      },
      employees: [],
      productHierarchyElementId: null,
      storeHierarchyElementId: null,
      geoHierarchyElementId: null,
      productIds: null,
      storeIds: null,
      retailerList: [],
      selectedRetailer: null,
      fields: [],
      fieldId: 77,
      startDate: moment("2020-04-02", "YYYY-MM-DD"),
      endDate: moment("2020-04-02", "YYYY-MM-DD"),
    };
  },
  methods: {
    clearData: function () {
      this.selectedRetailer = null;
      this.employeeId = null;
      this.treemapHierarchyId = null;
    },
    toggleEmployee: function (employee) {
      if (this.employeeIds.includes(employee.id)) {
        this.$store.commit("removeEmployeeToEmployeeList", { index: this.employeeIds.indexOf(employee.id) });
      } else {
        this.$store.commit("addEmployeeToEmployeeList", { index: this.employeeIds.length, value: employee.id });
      }
    },
    updateEmployeeList: async function () {
      let result = null;
      result = await BackendServices.getSalesforceEmployees(
        this.pagination,
        this.employeeSearch,
        true // only active employees
      );

      this.employeeCount = result.headers["x-total-count"];
      this.employees = result.data;
    },
    changePage: function (direction) {
      let maxPages = Math.ceil(
        this.employeeCount / this.pagination.rowsPerPage
      );

      if (direction === "left") {
        this.pagination.page =
          ((((this.pagination.page - 2) % maxPages) + maxPages) % maxPages) + 1;
      }

      if (direction === "right") {
        this.pagination.page =
          (((this.pagination.page % maxPages) + maxPages) % maxPages) + 1;
      }

      this.updateEmployeeList();
    },
  },
  computed: {
    salesFieldsButtonGroup: function () {
      return this.fields.map((i) => ({ label: i.button_label, value: i.id }));
    },
    salesFieldUnit: function () {
      return this.fields.filter((i) => i.id === this.fieldId).pop().unit_label;
    },
    employeeName: function () {
      let filteredEmployees = this.employees
        .filter((i) => this.employeeIds.includes(i.id));
      let result = '';
      if (filteredEmployees.length > 0) {
        for (let i = 0; i < filteredEmployees.length; i++) {
          result += filteredEmployees[i].name + ', '
        }
        result = result.substring(0, result.length - 2)
      }
      return result
    },
  },
  watch: {
    "$store.getters.getProductHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let productHierarchy = Object.values(
          this.$store.getters.getProductHierarchy
        ).filter((i) => i.length > 0);
        this.productHierarchyElementId =
          productHierarchy[productHierarchy.length - 1];
      },
    },
    "$store.getters.getStoreHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let storeHierarchy = Object.values(
          this.$store.getters.getStoreHierarchy
        ).filter((i) => i.length > 0);
        this.storeHierarchyElementId =
          storeHierarchy[storeHierarchy.length - 1];
      },
    },
    "$store.getters.getGeographyHierarchy": {
      immediate: true,
      deep: true,
      handler: function () {
        let geoHierarchy = Object.values(
          this.$store.getters.getGeographyHierarchy
        ).filter((i) => i.length > 0);
        this.geoHierarchyElementId = geoHierarchy[geoHierarchy.length - 1];
      },
    },
    "$store.getters.getDateRange": {
      immediate: true,
      deep: true,
      handler: function () {
        let { from, to } = this.$store.getters.getDateRange;
        this.startDate = moment(from, "YYYY/MM/DD");
        this.endDate = moment(to, "YYYY/MM/DD");
      },
    },
    "$store.getters.getProductList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.productIds) {
          this.productIds = [];
        }
        if (this.$store.getters.getProductList.length) {
          // this.productIds.splice(
          //   0,
          //   this.productIds.size,
          //   ...this.$store.getters.getProductList
          // );
          this.productIds = [...this.$store.getters.getProductList];
        } else {
          this.productIds = null;
        }
      },
    },
    "$store.getters.getStoreList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.storeIds) {
          this.storeIds = [];
        }

        if (this.$store.getters.getStoreList.length) {
          // this.storeIds.splice(
          //   0,
          //   this.storeIds.size,
          //   ...this.$store.getters.getStoreList
          // );
          this.storeIds = [...this.$store.getters.getStoreList];
        } else {
          this.storeIds = null;
        }
      },
    },
    "$store.getters.getSelectedRetailers": {
      immediate: true,
      deep: true,
      handler: function () {
        this.selectedRetailer = this.$store.getters.getSelectedRetailers;
      },
    },
    "$store.getters.getEmployeeList": {
      immediate: true,
      deep: true,
      handler: function () {
        if (!this.employeeIds) {
          this.employeeIds = [];
        }

        if (this.$store.getters.getEmployeeList.length) {
          this.employeeIds = [...this.$store.getters.getEmployeeList]
        } else {
          this.employeeIds = [];
        }
      },
    },
  },
};
